<template>
  <v-dialog
    v-model="show"
    @click:outside="close"
    class="login-dialog"
    max-width="750px"
  >
    <v-card color="lightPrimary pt-5">
      <v-card-title
        class="text-h5 text-center title-login-dialog primary--text d-flex align-center justify-center"
        >Remarcar Consulta
      </v-card-title>
      <v-card-text
        class="d-flex flex-column align-center justify-center text-center mt-3 pb-0"
      >
        <v-container>
          <v-row class="justify-center">
            <v-col class="col-12">
              <v-row
                class="ustify-center align-center flex-column"
                v-if="isLoading"
              >
                <p>Carregando...</p>
                <v-progress-circular
                  indeterminate
                  color="primary"
                  class="mb-0"
                ></v-progress-circular>
              </v-row>
              <v-row class="justify-center" v-if="!isLoading">
                <v-col class="col-12">
                  <div>
                    <v-autocomplete
                      solo
                      flat
                      hide-no-data
                      clearable
                      label="Fuso horário"
                      :items="time_zone"
                      v-model="time_zone_name"
                      @change="getTimeZone"
                      background-color="#F7F7F7"
                    ></v-autocomplete>
                  </div>
                  <v-date-picker
                    v-model="date"
                    :events="arrayEvents"
                    full-width
                    locale="pt-br"
                    event-color="secondary"
                    color="primary"
                    :min="minDate"
                    :picker-date.sync="pickerDate"
                  ></v-date-picker>
                  <div class="date__slected px-4 py-2">
                    <p>
                      Data selecionada:
                      <span>{{ date | formatDate }}</span>
                    </p>
                  </div>
                  <div class="my-3">
                    <h3 class="primary--text">Horários Disponíveis</h3>
                    <v-row class="row wrap px-3">
                      <v-radio-group v-model="selected">
                        <v-radio
                          class="list__hours"
                          v-for="(hour, index) in hoursOpen"
                          :key="index"
                          :label="hour.description"
                          :value="hour"
                        ></v-radio>
                      </v-radio-group>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="changeAppointmentDate" color="gray" class="ml-auto text-h6">
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment-timezone';
import Api from '../services/httpClient';
import { updateAppointmentDate } from '../services/psychologists';

export default {
  name: 'ModalReagendarConsulta',
  data() {
    return {
      loader: false,
      isDisabled: true,
      isLoading: false,
      dialog: false,
      user: {},
      value: '',
      selected: '',
      date: new Date().toISOString().substr(0, 10),
      arrayEvents: [],
      hoursOpen: [],
      page: 1,
      msg: '',
      time_zone: moment.tz.names(),
      time_offset: '',
      time_zone_name: '',
      pickerDate: null,
      loggedUserId: null,
      userCategory: '',
    };
  },
  props: {
    isDialogOpen: {
      type: Boolean,
      default: false,
    },
    codPsi: Number,
    codAppointment: Number,
  },
  async created() {
    await this.getTimeZone();
    await this.getHours();
  },
  watch: {
    /**
     * Reconhece quando uma a variavel date é modificada e chama a
     * função que pegar as horas livres daquela data.
     */
    async date() {
      this.isDisabled = true;
      await this.getHours();
    },
    /**
     * Verifica que ocorreu uma alteração na variavel $selected
     * e desabilita o botão Agendar.
     */
    selected(val) {
      if (val !== '') {
        this.isDisabled = false;
      }
    },

    time_zone_name(val) {
      if (val) {
        this.getHours();
      }
    },

    pickerDate(val) {
      this.monthYear(val);
    },
  },
  methods: {
    getHours() {
      Api.get(
        `/psychologists/${this.codPsi}/time_slots/`,
        {
          params: {
            date: this.date,
          },
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        },
      )
        .then(response => {
          this.listHours(response.data);
          this.selected = '';
        });
    },
    close() {
      this.$emit('close');
    },
    async changeAppointmentDate() {

      console.log(this.selected.value);
      let data = {
        newAppointmentId: this.selected.value,
      }

      const res = await updateAppointmentDate(data, this.codAppointment);

      console.log(res);

      if (res.status === 200) {
        this.close();
        this.$router.replace('/psicologo/dashboard/');
      }
    },
    /**
     * Através da array de horarios passado a função gera uma nova array
     * de objeos com value e description
     * { value 15:00, description 15h-16h}.
     */
    async listHours(val) {
      this.hoursOpen = [];
      const listFilter = await val.filter(item => {
        const utcThreshold = `${moment.utc().add(2, 'hours').format('YYYY-MM-DD HH:mm:ss')}`;
        const dateTime = `${item.date} ${item.time}`;
        return dateTime >= utcThreshold;
      });

      // eslint-disable-next-line no-restricted-syntax
      for (const item of listFilter) {
        item.time = moment
          .utc(`${item.date} ${item.time}`)
          .tz(`${this.time_zone_name}`)
          .format('HH:mm:ss');
        const splitTime = item.time.split(':');
        let axuDesc = parseInt(splitTime[0], 10) + 1;
        // eslint-disable-next-line prefer-template
        axuDesc = ('0' + axuDesc).substr(-2);
        // eslint-disable-next-line prefer-template
        const auxDescription = item.time.replace(':00:00', 'h') + '-' + axuDesc + 'h';
        const auxHours = {
          value: item.id,
          description: auxDescription,
        };
        this.hoursOpen.push(auxHours);
      }
    },
    /**
     * formata data e retorna para a função que vai informa ao datepicker
     * apartir de que data inicia.
     * params: $date
     */
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join('-');
    },
    async monthYear(value) {
      const res = value.split('-');
      const year = res[0];
      const month = res[1];
      if (year !== undefined && month !== undefined) {
        await this.allScheduleOpenMonth(month, year);
      }
    },
    getTimeZone() {
      const dataUser = localStorage.getItem('user-data');
      this.time_zone_name = JSON.parse(dataUser).time_zone_name;
    },
    /**
     * Pega o time zone escolhido pelo paciente
     */
    timeZone(val) {
      const m = moment().tz(val);
      this.time_offset = m.format('Z');
      this.time_zone_name = val;
    },
    /**
     * Pega todos os dias e horários vagos a partir do mês e ano selecionado
     * e coloca na variável arrayEvents para ser sinalizado
     * no datapicker os dias que tem horários vagos.
     */
    async allScheduleOpenMonth(month, year) {
      try {
        const { data, status } = await Api.get(
          `/psychologists/${this.codPsi}/time_slots/?year=${year}&month=${month}`,
          {
            headers: {
              Authorization: `Token ${localStorage.getItem('user-token')}`,
            },
          },
        );

        if (status === 200) {
          const utcThreshold = `${moment.utc().add(2, 'hours').format('YYYY-MM-DD HH:mm:ss')}`;
          // eslint-disable-next-line no-restricted-syntax
          for (const item of data) {
            const dateTime = `${item.date} ${item.time}`;
            if (dateTime >= utcThreshold && !this.arrayEvents.includes(item.date)) {
              this.arrayEvents.push(item.date);
            }
          }
        }
      } catch (error) {
        // console.log(error);
      }
    },
  },
  computed: {
    show: {
      get() {
        return this.isDialogOpen;
      },
      set(value) {
        return value;
      },
    },
    /**
     * Informa para o datepicker a data minima para ser escolhida.
     */
    minDate() {
      const today = new Date();
      return this.formatDate(today);
    },
  },
};
</script>

<style lang="css" scoped>
* >>> .v-dialog {
  box-shadow: none !important;
}

.title-login-dialog {
  word-break: break-word;
}

* >>> .list__hours {
  margin-top: 0px;
}

* >>> .list__hours .v-input--selection-controls__input {
  display: none;
}

* >>> .v-input--radio-group__input {
  display: flex;
  flex-direction: row !important;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
}

* >>> .list__hours {
  margin-bottom: 0;
  background: #cbcbcb;
  padding: 8px 16px;
  border-radius: 23px;
}

* >>> .list__hours.v-item--active {
  background: #02a554;
}

* >>> .list__hours.v-item--active .v-label {
  color: #fff;
}

* >>> .list__hours .v-label {
  color: #000000;
}

.date__slected {
  background-color: #e3ffe3;
}
.date__slected p {
  color: #6f6f6f;
  margin: 0;
  position: relative;
}
.date__slected p span {
  color: #02a554;
  font-size: 16px;
  font-weight: bold;
  position: absolute;
  right: 5px;
}

/* *>>> .v-date-picker-table .v-btn.v-btn--active,
*>>> .v-date-picker-table .v-btn.v-btn--outlined {
  border-radius: 28px;
} */
</style>